const TradeMarkBadge = ({ align = "right" }) => {
    return (
        <div className={`trade-mark-badge align-${align}`}>
            <span className={`trade-mark`}>ML Boosted</span>
        </div>
    );
}

export default TradeMarkBadge;